import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-blog-improving-card.css.lit';
import { OutlineContentCard } from '../../base/outline-content-card/outline-content-card';
import { classMap } from 'lit/directives/class-map.js';
import { LinkTargetType } from '../../base/outline-link/config';
import { getUrlTarget } from '../../../utilities/url_utils';

/**
 * The IDB Image Card component.
 * @element idb-content-card
 * @extends OutlineContentCard
 */
@customElement('idb-blog-improving-card')
export class BlogAndImprovingCard extends OutlineContentCard {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: 'url' })
  url: string;

  @property({ type: String, attribute: 'link-target' })
  linkTarget: LinkTargetType;

  render(): TemplateResult {
    this.linkTarget = getUrlTarget(this.url, this.linkTarget);
    const cardClasses = {
      'card': true,
      [`image-position--${this.imagePosition}`]: this.imagePosition,
      'outline-shadow': this.hasShadow,
      'outline-rounded-2xl': this.isRounded,
      [`outline-bg-${this.cardBackground}`]: this.cardBackground !== undefined,
      [`content-mode--${this.contentMode}`]: this.contentMode,
    };
    const imageClasses = {
      'card-image': true,
    };
    const contentWrapperClasses = {
      'card-content-wrapper': true,
      [`content-alignment--${this.contentAlignment}`]: this.contentAlignment,
    };
    const titleClasses = {
      'card-title': true,
      [`title-alignment--${this.titleAlignment}`]: this.titleAlignment,
      [`title-mode--${this.titleMode}`]: this.titleMode,
    };
    const summaryClasses = {
      'card-summary': true,
    };
    const contentClasses = {
      'card-content': true,
    };
    const ctaClasses = {
      'card-cta': true,
      [`cta-alignment--${this.ctaAlignment}`]: this.ctaAlignment,
    };

    /**
     * @todo Determine the best course for the background.
     *
     * We should determine if this is required edge to edge,
     * which looks a bit funny, or if the image (and content)
     * should be allowed to extend out to full bleed including
     * the container.
     *
     * Swapping the position of the container/section in this
     * render markup allows the background to go full bleed
     * instead of "page width".
     *
     * Removing the container completely allows it ALL
     * to be full bleed.
     */
    return html`
      <section class="${classMap(cardClasses)}">
        <a href="${this.url}" target="${this.linkTarget}">
          ${this.imageTemplate(imageClasses)}
          <section class="${classMap(contentWrapperClasses)}">
            ${this.titleTemplate(titleClasses)}
            ${this.summaryTemplate(summaryClasses)}
            ${this.contentTemplate(contentClasses)}
            ${this.ctaTemplate(ctaClasses)}
          </section>
        </a>
      </section>
    `;
  }
}
